import React, { Component } from 'react'
import { Redirect } from "react-router-dom";
import * as Yup from 'yup';
import Auth from '../../Auth'
import { setGrayBody } from './BodyBg'
import Source from '../../Source'
const source = new Source();
const auth = new Auth();

export class NotFound extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showLoading: false,
        }
    }

    componentDidMount() {
        setGrayBody();
    }

    render() {

        return (
            <div>
                <div className="text-center w-box pt-5 pb-5" >

                    <div style={{ width: '600px', height: '250px', margin: '0 auto' }} className="pt-5">

                        <div style={{paddingTop:'15px'}}>
                            <h2 className="font-bold">抱歉 <small>该模板已下架</small></h2>

                            <div className="m">
                                您可在“我的购买”页面下载查看
                    </div>
                        </div>
                    </div>





                </div>
            </div>
        );
    }
}

export default NotFound